import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { IMAGES } from "../../../assets/images/images";

const PropertyReviews = () => {
  return (
    <React.Fragment>
      <section className="commonpad">
        <Container fluid>
          <Row className="mb-5">
            <Col md={12}>
              <div className="proFlex proFlex1">
                <h2>Reviews (5)</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ul className="flexReview flexReviewM">
                <li>
                  <Image src={IMAGES.ReviewImg1} alt="" />
                  <div>
                    <div className="mediaFlex">
                      <div>
                        <h3>Dawson James</h3>
                        <div className="starRating">
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star" color="#E1C03F" />
                          <span className="starCount">4</span>
                        </div>
                      </div>
                      <span className="times">1 hr ago</span>
                    </div>
                    <p>
                      Sed ut perspiciatis unde omnis iste natus error sit
                      voluptatem accusantium doloremque laudantium, totam rem
                      aperiam, eaque ipsa quae ab illo inventore veritatis et
                      quasi architecto beatae vitae dicta sunt explicabo.
                    </p>
                  </div>
                </li>
                <li>
                  <Image src={IMAGES.ReviewImg1} alt="" />
                  <div>
                    <div className="mediaFlex">
                      <div>
                        <h3>Dawson James</h3>
                        <div className="starRating">
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star" color="#E1C03F" />
                          <span className="starCount">4</span>
                        </div>
                      </div>
                      <span className="times">1 hr ago</span>
                    </div>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco.
                    </p>
                  </div>
                </li>
                <li>
                  <Image src={IMAGES.ReviewImg1} alt="" />
                  <div>
                    <div className="mediaFlex">
                      <div>
                        <h3>Dawson James</h3>
                        <div className="starRating">
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star" color="#E1C03F" />
                          <span className="starCount">4</span>
                        </div>
                      </div>
                      <span className="times">1 hr ago</span>
                    </div>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco.
                    </p>
                  </div>
                </li>
                <li>
                  <Image src={IMAGES.ReviewImg1} alt="" />
                  <div>
                    <div className="mediaFlex">
                      <div>
                        <h3>Dawson James</h3>
                        <div className="starRating">
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star" color="#E1C03F" />
                          <span className="starCount">4</span>
                        </div>
                      </div>
                      <span className="times">1 hr ago</span>
                    </div>
                    <p>
                      Sed ut perspiciatis unde omnis iste natus error sit
                      voluptatem accusantium doloremque laudantium, totam rem
                      aperiam, eaque ipsa quae ab illo inventore veritatis et
                      quasi architecto beatae vitae dicta sunt explicabo.
                    </p>
                  </div>
                </li>
                <li>
                  <Image src={IMAGES.ReviewImg1} alt="" />
                  <div>
                    <div className="mediaFlex">
                      <div>
                        <h3>Dawson James</h3>
                        <div className="starRating">
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star-fill" color="#E1C03F" />
                          <Icon icon="ph:star" color="#E1C03F" />
                          <span className="starCount">4</span>
                        </div>
                      </div>
                      <span className="times">1 hr ago</span>
                    </div>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco.
                    </p>
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default PropertyReviews;
